module.exports = __webpack_public_path__ + "img/partner_icon5.25993129.png";